import { render, staticRenderFns } from "./PageCertifications.vue?vue&type=template&id=b2354470&scoped=true&"
import script from "./PageCertifications.vue?vue&type=script&lang=js&"
export * from "./PageCertifications.vue?vue&type=script&lang=js&"
import style0 from "./PageCertifications.vue?vue&type=style&index=0&id=b2354470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2354470",
  null
  
)

export default component.exports